export class PdaRegister {
  label: string;
  descrizione: string;
  id: string;
}
